import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ProfessionRegisterAffiliationServiceProxy, ProfessionRegisterAffiliationDto, ApplicationType } from '../../../shared/service-proxies/service-proxies';
import { SelectItemSortHelper } from '@shared/helpers/SelectItemSortHelper';
import { SelectItem } from '@node_modules/primeng/api';
import { AppConsts } from '@shared/AppConsts';

@Injectable({providedIn: 'root'})
export class ProfessionRegisterAffiliationService extends AppComponentBase {

    allProfessionRegisterAffiliations: ProfessionRegisterAffiliationDto[] = [];

    constructor(
        injector: Injector,
        private professionRegisterAffiliationService: ProfessionRegisterAffiliationServiceProxy,
    ) {
        super(injector);
    }

    loadAll(): Observable<ProfessionRegisterAffiliationDto[]> {
        return this.professionRegisterAffiliationService.getAll().pipe(
            tap(result => {
            this.allProfessionRegisterAffiliations = result;
            })
        );
    }

    getAllProfessions(): SelectItem[] {
        const professions = this.allProfessionRegisterAffiliations.map(x => x.id);
        return SelectItemSortHelper.translateAndOrderAlphabectically(professions, (str) => this.l(str));
    }

    getActiveProfessions(applicationType: ApplicationType): string[] {
        switch (applicationType) {
            case ApplicationType.Lia:
            case ApplicationType.LiaAndEhc:
            case ApplicationType.Sub:
            case ApplicationType.Abo:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForLiaId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Lia90Days:
            case ApplicationType.Ndqr:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForLia90DaysId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Alap:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForAlapId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.AlapExtr:
                return this.allProfessionRegisterAffiliations.filter(x => x.id === AppConsts.codes.profession.physician).map(x => x.id);
            case ApplicationType.Slap:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForSlapId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Ehc:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForEhcId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Ehc90Days:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForEhc90DaysId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Cogs:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForCogsId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Rla:
                return this.allProfessionRegisterAffiliations.filter(x => x.eligibleForRlaId === this.codes.yesNo.yes).map(x => x.id);
            case ApplicationType.Npbo:
                return this.allProfessionRegisterAffiliations.filter(x => x.id === AppConsts.codes.profession.physician || x.id === AppConsts.codes.profession.veterinarian).map(x => x.id);
            default:
                return [];
        }
    }

    getActiveProfessionsInAlphabeticOrder(applicationType: ApplicationType): SelectItem[] {
        const professions = this.getActiveProfessions(applicationType);
        return SelectItemSortHelper.translateAndOrderAlphabectically(professions, (str) => this.l(str));
    }
}
